import type { HTMLAttributes, ReactNode } from 'react'
import styles from './Banner.module.css'

export type BannerTone = 'win' | 'loss' | 'push' | 'brass' | 'info' | 'error'

export interface BannerProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  tone?: BannerTone
  /* Display-font headline above the message (result banners). */
  title?: ReactNode
  /* Shrink to content instead of filling the row. */
  inline?: boolean
  align?: 'left' | 'center'
  children?: ReactNode
}

/* Feedback strip: hint correct/wrong, hand result, form errors. */
export function Banner({ tone = 'info', title, inline, align = 'center', className, children, ...rest }: BannerProps) {
  const cls = [styles.banner, styles[tone], inline && styles.inline, align === 'left' && styles.alignLeft, className]
    .filter(Boolean).join(' ')
  return (
    <div className={cls} role={tone === 'error' ? 'alert' : undefined} {...rest}>
      {title && <span className={styles.title}>{title}</span>}
      {children}
    </div>
  )
}
